/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import CreateTemplateButton from 'ui/components/CreateTemplateButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

// Mixins
import listing from 'ui/mixins/workspaces/listing';
import restorable from 'ui/mixins/workspaces/restorable';

// Utils
import { get } from 'lodash';

/**
 * This component is the main Templates page controller.
 *
 * @category ui.pages
 * @exports TemplatesList
 * @component
 */
const __vue_script__ = {
    name: 'TemplatesList',

    components: { CreateTemplateButton, SearchBar },

    mixins: [listing, restorable],

    data() {
        const user = this.$services.user.getCurrentUser();

        return {
            canCreate: user.orgs.some(org => this.$services.user.hasPermission('templates.create_new', { org_id: org._id })),
            noTemplateImage: this.$utils.assets.imagePath('workspace-start.svg'),
            error: null,
            templates: [],
            viewTemplates: [],
            gettingStartedUrl: this.$utils.links.getLinkUrl('cms_template')
        };
    },

    computed: {

        noResults() {
            return (
                this.searchTerm.length > 0 &&
                this.viewTemplates.length === 0
            );
        },

        noDataAfterLoading() {
            return (
                this.searchTerm.length === 0 &&
                this.viewTemplates.length === 0 &&
                !this.loading
            );
        }
    },

    async created() {
        await this.getTemplates();

        this.viewTemplates = this.templates;
        this.loading = false;
    },

    methods: {
        /**
         * Returns the user Templates, alphabetically sorted, and filtered by user's orgs.
         */
        async getTemplates() {
            try {
                // global only superadmin, or private where they are team members
                const { templates } = await this.$services.template.getOrgTemplates(null, false);

                this.templates = this.$services.template.sortByOrderAndName(templates, this.$i18n.locale);
            } catch (error) {
                this.error = get(error, 'response.data.error') || error.message;
            }
        },


        /**
         * Reset the filtered search result to the inital dataset
         */
        resetSearch() {
            this.viewTemplates = this.templates;
        },

        /**
         * Filter the templates by the search input
         */
        filterSearch() {
            const searchTerm = this.searchTerm
                .trim()
                .split(' ')
                .map(e => e.toLocaleLowerCase());

            const filter = (t = {}) => {
                const title = this.$utils.locales.localizeLabel(t.description.title, this.$i18n.locale);
                const description = this.$utils.locales.localizeLabel(t.description.subtitle, this.$i18n.locale);
                const combi = `${title}${description}${t.org || ''}${t.orgDisplayName || ''}`.toLocaleLowerCase();

                return searchTerm.some(e => combi.indexOf(e) !== -1);
            };

            this.viewTemplates = this.templates.filter(filter);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"inner-page workspaces-listing",attrs:{"status":_vm.loading}},[(!_vm.error && !_vm.noDataAfterLoading)?_c('section',{staticClass:"page-content templates-page"},[_c('div',{staticClass:"search",class:[ _vm.noResults ? 'no-results' : '']},[(!_vm.loading && _vm.canCreate)?_c('create-template-button',{staticClass:"create",attrs:{"user":_vm.params.user}}):_vm._e(),_c('search-bar',{attrs:{"results":!_vm.noResults},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('a',{staticClass:"browse",attrs:{"href":_vm.$t('templates.website_link'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('templates.website_link_label')))])])],1),(!_vm.noResults)?_c('div',{staticClass:"section-list"},[_c('workspaces-list',{attrs:{"workspaces":_vm.viewTemplates,"mode":"WorkspaceTemplate","uid-prefix":"tpl","highlightArchived":_vm.canSeeArchived},on:{"click":_vm.checkLifecycle}})],1):_vm._e()]):_vm._e(),(_vm.error)?_c('div',{staticClass:"alert alert-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e(),(_vm.noDataAfterLoading)?_c('div',{staticClass:"no-data"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.noTemplateImage),expression:"noTemplateImage"}],attrs:{"silent":false}}),_c('h1',{staticClass:"welcome"},[_vm._v(_vm._s(_vm.$t('templates.welcome')))]),(!_vm.canCreate)?_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("templates.no_templates")))]):_vm._e(),(_vm.canCreate)?_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("templates.no_templates_admin")))]):_vm._e(),(_vm.canCreate)?_c('create-template-button',{staticClass:"create",attrs:{"user":_vm.params.user}}):_vm._e(),_c('br'),_c('a',{attrs:{"href":_vm.gettingStartedUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('templates.learn_more')))])],1):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TemplatesList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__